import { useEffect, useMemo, useState, useRef } from 'react';
import { ENDPOINTS } from '../../../Utils/Endpoints';
import { Models } from '../../../Utils/ModelsLMS';
import ConfirmDeleteDialog from '../../../../security/ConfirmDeleteDialog';
import { normalizeValue } from '../../../../../utils/Texts';
import axios from 'axios';
import Modal from './NivelesModal';
import sigmaDelete from '../../../../Pages/img/Borrar.png';
import sigmaEdit from '../../../../Pages/img/Editar.png';
import AlertDialog from '../../Shared/AlertDialog';
import { getSessionEmpresaId, isSessionSuperAdmin } from '../../../../../utils/SessionUser';
import { useResourcePermissions } from '../../../../../utils/useResourcePermissions';

const PAGE_SIZE = 10;
const nombreTabla = "Niveles";
const endpoint = ENDPOINTS.catNivel;
const endpointById = ENDPOINTS.catNivelById;
const modelo = Models.niveles;



const maps = {
  mapCreate: (f) => ({
    nombre: f.nombre,
    descripcion: f.descripcion,
    activo: true,
    idEmpresa: getSessionEmpresaId(),
  }),
  mapUpdate: (id, f) => ({
    idNivel: id,
    nombre: f.nombre,
    descripcion: f.descripcion,
    activo: true,
    idEmpresa: f.idEmpresa || null,
  }),
};

export default function Catalog() {
  const { puedeCrear, puedeEditar, puedeEliminar } = useResourcePermissions('NivelesCursos');
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [cursos, setCursos] = useState([]);
  const [query, setQuery] = useState('');
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState('new');
  const [selectedId, setSelectedId] = useState(null);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState({ id: 0, name: '' });
  const [editData, setEditData] = useState(null);
  const [page, setPage] = useState(1);
  const [alertConfig, setAlertConfig] = useState({ open: false, message: '', title: 'Información', variant: 'info' });

  const triggerAlert = (message, variant = 'error', title = 'Error') => {
    setModalOpen(false);
    setDeleteOpen(false);
    setAlertConfig({ open: true, message, variant, title });
  };

  const editorRef = useRef(null);

  useEffect(() => {
    if (modalOpen && editorRef.current) {
      editorRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [modalOpen, selectedId]);

  const loadData = async () => {
    setLoading(true);
    try {
      const [resNiveles, resCursos] = await Promise.all([
        axios.get(endpoint),
        axios.get(ENDPOINTS.cursos)
      ]);
      setRows((resNiveles.data || []).map((x) => modelo(x)));
      setCursos((resCursos.data || []).map(x => Models.cursos(x)));
    } catch (e) {
      console.error(e);
      triggerAlert('Error al cargar información');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { loadData(); }, []);

  const filtered = useMemo(() => {
    const sessionEmpresaId = getSessionEmpresaId();
    const q = query.trim().toLowerCase();
    let res = rows;

    if (sessionEmpresaId) {
      res = res.filter(r => r.idEmpresa === sessionEmpresaId);
    }

    if (!q) return res;

    return res.filter((r) => {
      const nombre = (r.nombre || '').toLowerCase();
      const desc = (r.descripcion || '').toLowerCase();

      return nombre.includes(q) || desc.includes(q);
    });
  }, [rows, query]);

  const totalPages = Math.ceil(filtered.length / PAGE_SIZE);
  const paged = useMemo(() => {
    const start = (page - 1) * PAGE_SIZE;
    return filtered.slice(start, start + PAGE_SIZE);
  }, [filtered, page]);

  const handleNew = () => {
    setModalMode('new');
    setSelectedId(null);
    setEditData(null);
    setModalOpen(true);
  };

  const handleEdit = async (id) => {
    try {
      setLoading(true);
      const res = await axios.get(endpointById(id));
      const modelData = modelo(res.data);
      setEditData(modelData);
      setModalMode('edit');
      setSelectedId(id);
      setModalOpen(true);
    } catch (e) {
      console.error(e);
      triggerAlert('Error al cargar detalle');
    } finally {
      setLoading(false);
    }
  };

  const askDelete = (id, name) => {
    setDeleteTarget({ id, name });
    setDeleteOpen(true);
  };

  const doDelete = async () => {
    setDeleteOpen(false);
    setLoading(true);
    try {
      await axios.delete(endpointById(deleteTarget.id));
      triggerAlert('Nivel eliminado con éxito', 'success', 'Éxito');
      await loadData();
    } catch (e) {
      console.error(e);
      triggerAlert('Error al eliminar');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (payload, mode) => {
    try {
      setLoading(true);
      if (mode === 'new') {
        await axios.post(endpoint, maps.mapCreate(payload));
      } else {
        await axios.put(endpoint, maps.mapUpdate(selectedId, payload));
      }
      setModalOpen(false);
      await loadData();
    } catch (e) {
      console.error(e);
      triggerAlert('Error al guardar');
    } finally {
      setLoading(false);
    }
  };

  const PageBtn = ({ label, onClick, active, disabled }) => (
    <button
      type="button"
      className={`roles-page-btn ${active ? 'is-active' : ''} ${disabled ? 'is-disabled' : ''}`}
      onClick={onClick}
      disabled={disabled}
    >{label}</button>
  );

  const pageNumbers = (() => {
    const maxToShow = 5;
    let start = Math.max(1, page - 2);
    let end = Math.min(totalPages, start + maxToShow - 1);
    start = Math.max(1, end - maxToShow + 1);
    return Array.from({ length: Math.max(0, end - start + 1) }, (_, i) => start + i);
  })();

  const startIndex = filtered.length === 0 ? 0 : (page - 1) * PAGE_SIZE + 1;
  const endIndex = Math.min(page * PAGE_SIZE, filtered.length);

  return (
    <div className="panel-sigma-main">
      <div className="roles-shell">
        <div className="roles-topbar">
          <h2 className="roles-title">{nombreTabla}</h2>

          <input
            className="roles-search"
            placeholder="Buscar por nombre, descripción o activo…"
            value={query}
            onChange={(e) => { setQuery(e.target.value); setPage(1); }}
          />
          {puedeCrear && <button className="btn-action" onClick={handleNew}>＋ Nuevo</button>}
        </div>

        <div className="roles-table-wrap">
          <div className="roles-table-scroller">
            <table className="roles-table">
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th>Descripción</th>
                  <th>Empresa</th>
                  {puedeEditar && <th style={{ textAlign: 'center' }}>Editar</th>}
                  {puedeEliminar && <th style={{ textAlign: 'center' }}>Borrar</th>}
                </tr>
              </thead>
              <tbody>
                {paged.map((r) => {
                  const isSuperAdmin = isSessionSuperAdmin();
                  const isGlobal = !r.idEmpresa;
                  const isLocked = isGlobal && !isSuperAdmin;
                  const isInUse = cursos.some(c => Number(c.idNivel) === Number(r.idNivel) && c.activo);

                  return (
                    <tr key={r.idNivel}>
                      <td><strong>{normalizeValue(r.nombre)}</strong></td>
                      <td>{normalizeValue(r.descripcion)}</td>
                      <td>
                        <span style={{ fontSize: '0.85rem', color: r.idEmpresa ? '#334155' : '#94a3b8' }}>
                          {r.idEmpresa ? r.nombreEmpresa : 'Global'}
                        </span>
                      </td>
                      {puedeEditar && (
                        <td style={{ textAlign: 'center' }}>
                          <button
                            type="button"
                            className="rk-iconbtn rk-iconbtn--edit"
                            onClick={() => !isLocked && handleEdit(r.idNivel)}
                            disabled={isLocked}
                            aria-label="Editar"
                            title={isLocked ? "Bloqueado: Registro global" : "Editar"}
                            style={isLocked ? { opacity: 0.5, cursor: 'not-allowed', filter: 'grayscale(100%)' } : {}}
                          >
                            <img src={sigmaEdit} alt="" className="rk-ico" />
                          </button>
                        </td>
                      )}
                      {puedeEliminar && (
                        <td style={{ textAlign: 'center' }}>
                          <button
                            type="button"
                            className="rk-iconbtn rk-iconbtn--del"
                            onClick={() => {
                              if (!isLocked && !isInUse) {
                                askDelete(r.idNivel, r.nombre || `Nivel ${r.idNivel}`);
                              }
                            }}
                            disabled={isLocked || isInUse}
                            aria-label="Borrar"
                            title={isLocked ? "Bloqueado: Registro global" : isInUse ? "Bloqueado: Nivel en uso por cursos activos" : "Borrar"}
                            style={(isLocked || isInUse) ? { opacity: 0.5, cursor: 'not-allowed', filter: 'grayscale(100%)' } : {}}
                          >
                            <img src={sigmaDelete} alt="" className="rk-ico" />
                          </button>
                        </td>
                      )}
                    </tr>
                  );
                })}
                {!loading && paged.length === 0 && (<tr><td colSpan={3 + (puedeEditar ? 1 : 0) + (puedeEliminar ? 1 : 0)}>Sin resultados.</td></tr>)}
              </tbody>
            </table>
          </div>
        </div>

        <div className="roles-pagination">
          <div className="roles-pagination-left">
            {filtered.length > 0
              ? <span>Mostrando {startIndex}–{endIndex} de {filtered.length}</span>
              : <span>0 resultados</span>}
          </div>
          <div className="roles-pagination-right">
            <PageBtn label="‹" onClick={() => setPage((p) => Math.max(1, p - 1))} disabled={page === 1} />
            {pageNumbers.map(n => (<PageBtn key={n} label={n} onClick={() => setPage(n)} active={n === page} />))}
            <PageBtn label="›" onClick={() => setPage((p) => Math.min(totalPages, p + 1))} disabled={page === totalPages} />
          </div>
        </div>

        {modalOpen && (
          <div className="roles-editor-slot" ref={editorRef}>
            <Modal
              open={modalOpen}
              mode={modalMode}
              data={editData}
              inline
              onClose={() => setModalOpen(false)}
              onSubmit={handleSubmit}
            />
          </div>
        )}
      </div>

      <ConfirmDeleteDialog
        open={deleteOpen}
        roleName={deleteTarget.name}
        onClose={() => setDeleteOpen(false)}
        onConfirm={doDelete}
      />

      <AlertDialog
        open={alertConfig.open}
        title={alertConfig.title}
        message={alertConfig.message}
        variant={alertConfig.variant}
        onClose={() => setAlertConfig({ ...alertConfig, open: false })}
      />
    </div>
  );
}
